class BxfButtonConstants {
    static COMPONENT_NAME = 'bxf-button';
    static STRING = {
        BUTTON_CONTAINER: 'bxf-button__container',
        BUTTON_SPLIT_CONTAINER: 'bxf-button__split-container',
        BUTTON_SPLIT_LEFT: 'bxf-button__split-button--left',
        BUTTON_SPLIT_RIGHT: 'bxf-button__split-button--right',
        BUTTON_ROUNDED_BORDER: 'bxf-button__rounded-border',
        BUTTON_SQUARED_BORDER: 'bxf-button__squared-border',
        GROUP: 'group',
        CONTENT: 'bxf-button__content',
        PRIMARY: 'primary',
        REGULAR: 'regular',
        BUY_PRIMARY: 'buy-primary',
        BUY_SECONDARY: 'buy-secondary',
        SELL_PRIMARY: 'sell-primary',
        SELL_SECONDARY: 'sell-secondary',
        BUTTON_ACTIVE: 'bxf-button__active',
        PRIMARY_BUTTON: 'primary-button',
        SECONDARY_BUTTON_ACTIVE: 'bxf-button__secondary--active',
        TERTIARY_BUTTON: 'tertiary-button',
        BXF_BUTTON_PRIMARY: 'bxf-button__primary',
        BXF_BUTTON_SECONDARY: 'bxf-button__secondary',
        BXF_BUTTON_TERTIARY: 'bxf-button__tertiary',
        BXF_BUTTON_TERTIARY_ACTIVE: 'bxf-button__tertiary--active',
        BXF_BUTTON_TERTIARY_SUBTLE: 'bxf-button__tertiary-subtle',
        BXF_BUTTON_TERTIARY_SUBTLE_ACTIVE: 'bxf-button__tertiary-subtle--active',
        NO_PADDING: 'bxf-button__no-padding',
    };
}

export { BxfButtonConstants as B };
